import { isPlaidBankLink } from 'v3/api/core/apiConfig';
import { useConnectBankAccount } from 'v3/hooks/useConnectBankAccount';
import { useStripeBankAccount } from 'v3/hooks/useStripeBankAccount';

/**
 * The bank-linking hook for the configured provider.
 *
 * Chosen once at module load rather than branched inside a component, which is what keeps
 * it legal under the rules of hooks: there is a single call site, only one implementation
 * is ever mounted, and the choice cannot change between renders. Branching per render would
 * also make the unselected provider fetch a link token it never uses.
 *
 * Both hooks report through the same neutral shape, so neither the pages nor this module
 * has to translate between them.
 */
export const useBankAccountLink = isPlaidBankLink ? useConnectBankAccount : useStripeBankAccount;
